import { Consultorio } from '../../models/Entities/Turnero';
import { CommonState } from '../common/state/commonState';

export interface TurneroConsultoriosState extends CommonState<Consultorio> {
    disponibles: Consultorio[];
    disponiblesPorDoctor: Consultorio[];

    isLoadingDisponibles: boolean;
    successLoadingDisponibles: boolean | undefined;
    failOnLoadingDisponibles: boolean;

    isLoadingDisponiblesDoctor: boolean;
    successLoadingDisponiblesDoctor: boolean | undefined;
    failOnLoadingDisponiblesDoctor: boolean;

    isUpdatingEstado: boolean;
    successUpdatingEstado: boolean | undefined;
    failOnUpdatingEstado: boolean;
}

export const TurneroConsultoriosUnloadState: any = {
    // loading all
    isLoadingAll: false,
    isLoadingAllSuccess: undefined,
    FailGettingAll: false,

    // updating all
    isUpdatingAll: false,
    isUpdatingAllSuccess: undefined,
    FailUpdatingAll: false,

    // loading one
    isLoadingOne: false,
    isLoadingOneSuccess: undefined,
    FailGettingOne: false,

    // updating
    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,
    
    // adding
    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    // deleting
    isDeletingOne: false,
    isDeletingOneSuccess: undefined,
    FailDeletingOne: false,

    // list and error
    list: [],
    error: undefined,

    // custom collections
    disponibles: [],
    disponiblesPorDoctor: [],

    // custom flags
    isLoadingDisponibles: false,
    successLoadingDisponibles: undefined,
    failOnLoadingDisponibles: false,

    isLoadingDisponiblesDoctor: false,
    successLoadingDisponiblesDoctor: undefined,
    failOnLoadingDisponiblesDoctor: false,

    isUpdatingEstado: false,
    successUpdatingEstado: undefined,
    failOnUpdatingEstado: false
};
